import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "efj"
}
const _hoisted_2 = {
  key: 4,
  class: "efj__fixed"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__online--icon",
  src: "img/icons/offline.svg",
  alt: "Offline",
  style: {"display":"none"}
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "efj__online"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__online--icon",
  src: "img/icons/online.svg",
  alt: "Online"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "efj__online"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__online--icon",
  src: "img/icons/offline.svg",
  alt: "Offline"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "efj__brand efj__brand--textcolor efj__brand--small" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__brand--icon",
  src: "img/background/wappen.svg",
  alt: "Brand"
}, null, -1)
const _hoisted_12 = { class: "efj__brand--text-container" }
const _hoisted_13 = { class: "efj__brand--text" }
const _hoisted_14 = { class: "efj__router--small" }
const _hoisted_15 = { class: "efj__router--reset container-fluid d-flex row g-0" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = {
  key: 5,
  class: "efj__fixed"
}
const _hoisted_18 = {
  key: 0,
  class: "efj__online"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__online--icon",
  src: "img/icons/online.svg",
  alt: "Online"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "efj__online"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__online--icon",
  src: "img/icons/offline.svg",
  alt: "Offline"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "efj__brand efj__brand--textcolor efj__brand--big" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "efj__brand--icon",
  src: "img/background/wappen.svg",
  alt: "Brand"
}, null, -1)
const _hoisted_26 = { class: "efj__brand--text-container" }
const _hoisted_27 = { class: "efj__brand--text" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "efj__online efj__online--big" }, null, -1)
const _hoisted_29 = { class: "efj__router--big" }
const _hoisted_30 = { class: "efj__router--reset container-fluid d-flex row g-0" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = {
  id: "efjBottomWebShopNavbar",
  class: "efj__bottom-webshop-navbar"
}
const _hoisted_33 = { class: "container-fluid d-flex row g-0" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = {
  id: "efjBottomNavbar",
  class: "efj__bottom-navbar"
}
const _hoisted_36 = { class: "container-fluid d-flex row g-0" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"pre__load\"><img src=\"img/icons/notsynced.svg\" alt=\"\"><img src=\"img/icons/synced.svg\" alt=\"\"><img src=\"img/icons/cancel.svg\" alt=\"\"><img src=\"img/icons/report.svg\" alt=\"\"><img src=\"img/icons/failedsync.svg\" alt=\"\"><img src=\"img/icons/filter.svg\" alt=\"\"><img src=\"img/icons/fischbuch.svg\" alt=\"\"><img src=\"img/icons/fischli.svg\" alt=\"\"><img src=\"img/icons/fischli-g.svg\" alt=\"\"><img src=\"img/icons/fischli-o.svg\" alt=\"\"><img src=\"img/icons/fischli-r.svg\" alt=\"\"><img src=\"img/icons/hirsch.svg\" alt=\"\"><img src=\"img/icons/hirsch-g.svg\" alt=\"\"><img src=\"img/icons/hirsch-o.svg\" alt=\"\"><img src=\"img/icons/hirsch-r.svg\" alt=\"\"><img src=\"img/icons/fischprodukt.svg\" alt=\"\"><img src=\"img/icons/fish_white.svg\" alt=\"\"><img src=\"img/icons/home.svg\" alt=\"\"><img src=\"img/icons/paging.svg\" alt=\"\"><img src=\"img/icons/logout.svg\" alt=\"\"><img src=\"img/icons/navigate-back.svg\" alt=\"\"><img src=\"img/icons/navigate-next.svg\" alt=\"\"><img src=\"img/icons/next_white.svg\" alt=\"\"><img src=\"img/icons/offline.svg\" alt=\"\"><img src=\"img/icons/online.svg\" alt=\"\"><img src=\"img/icons/onoffline.svg\" alt=\"\"><img src=\"img/icons/paging_selected.svg\" alt=\"\"><img src=\"img/icons/previous_white.svg\" alt=\"\"><img src=\"img/icons/products_white.svg\" alt=\"\"><img src=\"img/icons/produkte.svg\" alt=\"\"><img src=\"img/icons/refresh.svg\" alt=\"\"><img src=\"img/icons/schliessen_grau.svg\" alt=\"\"><img src=\"img/icons/settings_white.svg\" alt=\"\"><img src=\"img/icons/info_label.svg\" alt=\"\"><img src=\"img/icons/gps-position-edit.svg\" alt=\"\"><img src=\"img/icons/gps-position.svg\" alt=\"\"><img src=\"img/icons/geo-center.svg\" alt=\"\"><img src=\"img/icons/trash.svg\" alt=\"\"><img src=\"img/icons/einkauf.svg\" alt=\"\"><img src=\"img/icons/warenkorb.svg\" alt=\"\"><img src=\"img/icons/jagen.svg\" alt=\"\"><img src=\"img/icons/fallwild.svg\" alt=\"\"><img src=\"img/icons/beobachtung.svg\" alt=\"\"><img src=\"img/icons/beobachtungspez.svg\" alt=\"\"><img src=\"img/icons/jagd.svg\" alt=\"\"></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup = _resolveComponent("popup")!
  const _component_notification_popup = _resolveComponent("notification-popup")!
  const _component_error_popup = _resolveComponent("error-popup")!
  const _component_loader_popup = _resolveComponent("loader-popup")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_webshop_payment_nav_bar = _resolveComponent("webshop-payment-nav-bar")!
  const _component_routed_navigation_bar = _resolveComponent("routed-navigation-bar")!
  const _component_actions = _resolveComponent("actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.modalDialogName !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "on:okClick": _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.modalDialogClosed && $setup.modalDialogClosed(...args))),
          "on:cancelClick": _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.modalDialogCanceled && $setup.modalDialogCanceled(...args))),
          class: _normalizeClass($setup.modalDialogName)
        }, [
          _createVNode(_component_popup, {
            onOkClick: $setup.modalDialogClosed,
            onCancelClick: $setup.modalDialogCanceled
          }, null, 8, ["onOkClick", "onCancelClick"])
        ], 34))
      : _createCommentVNode("", true),
    ($setup.notificationParameter.isNotification)
      ? (_openBlock(), _createBlock(_component_notification_popup, _mergeProps({
          key: 1,
          onClosed: $setup.notificationClosed
        }, $setup.notificationParameter), null, 16, ["onClosed"]))
      : _createCommentVNode("", true),
    ($setup.errorDialogParameter.isError)
      ? (_openBlock(), _createBlock(_component_error_popup, _mergeProps({
          key: 2,
          onClosed: $setup.errorClosed
        }, $setup.errorDialogParameter), null, 16, ["onClosed"]))
      : _createCommentVNode("", true),
    ($setup.loaderParameter.isInProgress)
      ? (_openBlock(), _createBlock(_component_loader_popup, _normalizeProps(_mergeProps({ key: 3 }, $setup.loaderParameter)), null, 16))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "efj__background",
      style: _normalizeStyle({ backgroundImage: `url('${$setup.waterMarkImage}')` })
    }, null, 4),
    ($setup.showHeaderSection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          ($setup.online)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          (!$setup.online)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString($setup.kanton), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!$setup.showHeaderSection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          ($setup.online)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true),
          (!$setup.online)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString($setup.kanton), 1)
            ])
          ]),
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_webshop_payment_nav_bar)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          ($setup.showRoutedBar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_routed_navigation_bar)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_actions)
              ]))
        ])
      ])
    ]),
    _hoisted_40
  ]))
}